import React from 'react';
import clsx from 'clsx';
import Depot from '../../../_shared/depot';
import * as styles from './style.module.css';
import Paragraph from '../../../Typography/Paragraph';
const SupportMessageWithoutRef = ({ supportMessage: SupportMessage, ...commonProps }) => {
    // Derived values
    const messageIsComponent = SupportMessage && typeof SupportMessage !== 'string';
    // Classes
    const paragraphClasses = clsx(styles.supportMessage);
    return (React.createElement(Paragraph, { ...commonProps, typeStyle: "small", as: "span", fontWeight: "regular", color: "subdued", className: paragraphClasses }, messageIsComponent ? React.createElement(SupportMessage, null) : SupportMessage));
};
const SupportMessage = Depot.withRef(SupportMessageWithoutRef);
SupportMessage.displayName = 'SupportMessage';
export default SupportMessage;
//# sourceMappingURL=index.js.map